<template>
  <div>
    <!-- 抽屉 -->
    <el-drawer
    :append-to-body="true"
      class="drawer"
      title="上传成功设备列表"
      :visible.sync="fileListDialog"
      :before-close="handleClose">
      <div class="container">
         <el-table
          ref="multipleTable"
          :data="deviceDetail.slice((listQuery.page-1)*listQuery.limit,listQuery.page*listQuery.limit)"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}">
          <el-table-column
            prop="deviceName"
            label="DeviceName"
            >
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column
            prop="productKey"
            label="productKey"
            >
          </el-table-column>
          <el-table-column
            prop="moduleVersion"
            label="版本号"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            :total="total"
            :page-size="listQuery.limit"
            :page-sizes="[10,20,50]"
            :current-page="listQuery.page"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="currentChange">
          </el-pagination>
        </el-row>
      </div>
      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="handleClose"
          >
            确定
          </el-button>
        </div>
       <!--  <span>
          已选择 <i>{{count}}</i> 个设备
        </span> -->
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import Bus from '@/assets/js/eventBus.js'
export default {
  props: {
    deviceDetail: {
      type: Array,
      default: function () {
        return []
      }
    },
    fileListDialog: {
      type: Boolean
    }
  },
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      }
      /* list: [
        {
          deviceName: 'wfs_device_local1',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local2',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local3',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local4',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local5',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local6',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local7',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local8',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local9',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },
        {
          deviceName: 'wfs_device_local10',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        },

        {
          deviceName: 'wfs_device_local11',
          moduleVersion: 'wfs_device_local',
          productKey: 'wfs_device_local'
        }
      ] */
    }
  },
  watch: {
    deviceDetail: {
      immediate: true,
      handler (val) {
        console.log(val)
        this.total = val.length
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    handleClose (done) {
      this.$emit('closeFileDrawer')
    },
    // 分页管理
    currentChange (val) {
      this.listQuery.page = val
    },
    // 改变页码
    handleSizeChange (val) {
      this.listQuery.limit = val
    }
  }
}
</script>

<style lang='less' scoped>
.drawer{
    /deep/ .el-drawer__header{
      line-height: 60px !important;
      font-size: 18px !important;
      height: 60px !important;
      border-bottom: 1px solid #efefef !important;
      padding: 0 24px !important;
      margin-bottom: 0 !important;
    }
    /deep/ .el-drawer__body{
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
      .container{
        margin-bottom: 64px;
        padding: 16px 24px 0 24px !important;
        border-top: 1px solid #ececec;
        .screen{
          display: flex;
          margin-bottom: 20px;
          /deep/ .el-input{
            margin-left: 0;
            width: 90%;
          }
        }
        /deep/ .el-table::before{
          background: white;
        }
        /deep/ .el-table th>.cell:first-child{
          padding: 0 14px
        }
        /* .cell:first-child{

        } */
      }
      .drawer-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #ececec;
        margin-top: 10px;
        padding: 10px 24px ;
        height:64px;

        position: fixed;
        bottom: 0;
        /* display: block; */
        background: white;
        z-index: 10000;
        width: 100%;
        i{
          color: #409eff;
          font-style: normal;
        }
      }
    }
    /deep/ :focus {
      outline: 0;
    }
  }
</style>
